import { useContext, useMemo } from "react";
import { AuthContext } from "../../../../Moduels/Context/AuthContext";
import AttendanceHub from "../AttendanceHub";
import AdminAttendanceView from "./AdminAttendanceView";
import EmployeeAttendanceView from "./EmployeeAttendanceView";

function resolveRole(me, authRole) {
  return String(me?.role || me?.user?.role || authRole || "employee").toLowerCase();
}

function resolveEmployeeId(me) {
  if (!me) return null;
  return (
    me?.employee?.employee_id ??
    me?.employee_id ??
    (me?.legacy ? me?.employee?.employee_id : null) ??
    null
  );
}

function isAdminRole(role) {
  return ["admin", "hr", "superadmin", "super_admin"].includes(role);
}

/** Index route: hub for admin/hr, self-service for employees. */
export default function AttendanceHome() {
  const { user, role: authRole, loading } = useContext(AuthContext);
  const role = useMemo(() => resolveRole(user, authRole), [user, authRole]);
  const employeeId = useMemo(() => resolveEmployeeId(user), [user]);

  if (loading) {
    return (
      <div className="p-8 text-center text-slate-500 text-sm">Loading attendance…</div>
    );
  }

  if (isAdminRole(role)) {
    return <AttendanceHub />;
  }

  if (!employeeId) {
    return (
      <div className="p-8 max-w-lg mx-auto text-center text-slate-600 text-sm">
        Unable to load your employee profile. Sign in with your employee account or contact HR.
      </div>
    );
  }

  return <EmployeeAttendanceView userId={employeeId} profile={user} />;
}

/** Weekly admin dashboard (all employees). */
export function AttendanceWeeklyAdmin() {
  return <AdminAttendanceView />;
}
